import { PatientVisit } from "./../../outpatient/patient-visit/patient-visit";
import {
  Component,
  ViewEncapsulation,
  Input,
  Output,
  OnChanges,
  ElementRef,
  EventEmitter,
  AfterViewInit,
  NgModule,
  OnInit,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes, ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ExportAsConfig, ExportAsService } from "ngx-export-as";
// import * as jsPDF from "jsPDF";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { PDFDocument, PDFPage, rgb } from 'pdf-lib';
import { MedicalRepositoryService } from "../../medical-recored/medical-repository.service";
import { SmsService } from "../../promotions/SmsService/Sms.service";
import { UserSessionService } from "../../app-user-session.service";
import { ToastService } from "../toast";
@Component({
  selector: "app-print-page",
  encapsulation: ViewEncapsulation.None,
  template: `
    <section
      id="{{ section }}_abc"
      [ngStyle]="pgStyle"
      class="printpage"
      size="A4"
      [style.width.mm]="210"
      [style.height.mm]="297" >
      <div style="display: flex;justify-content: space-between;padding: 1px;">
      <button (click)="printDiv()" class="btn btn-sm btn-info">
        <i class="fa fa-print"></i>
        {{translate.currentLang == 'ar'? 'طباعة' :'Print'}}
      </button>
      <button *ngIf="whatsAppSendingPermission==1" (click)="sendFile()" class="btn btn-sm btn-success" type="button"
                style="box-shadow: 6px 5px 4px 0px rgb(3 13 2 / 50%);">
                <i  class="fa fa-whatsapp"></i>
                {{translate.currentLang == 'ar'? 'الواتساب' :'WhatsApp'}}
            </button>
      </div>
      <iframe #printHtml5Iframe style="width:100%;height:100%"></iframe>
      <div id="printpage"></div>
    </section>
  `,
}) export class PrintComponent implements OnChanges {
  cssRefs = `<link rel="stylesheet" href="assets/css/gutenberg.css" media="screen,print">
  <link type="text/css" rel="stylesheet" href="assets/css/fontawesome-all.min.css">
  <link type="text/css" rel="stylesheet" href="assets/css/vendor/bootstrap/bootstrap.min.js">
  <link rel="stylesheet" href="assets/css/emrgeneralprint.css" >
  `;
  sectionCss = "";
  @ViewChild("printHtml5Iframe") printHtml5Iframe: ElementRef;
  @Output() pdfBase64 = new EventEmitter<any>();
  @Input("section") section: string;
  @Input() pgStyle: string;
  @Input() includefontAwsom: boolean = true;
  @Input() backgroundFlag: boolean = false;
  _whatsAppData: any = {};
  whatsAppSendingPermission: number = 0;
  @Input() set whatsAppData(value) {
    if (value) {
      this._whatsAppData = value;
      this.mobile = value.phoneNumber;
      this.caption = value.caption;
      this.whatsAppSendingPermission = value.whatsAppSendingPermission;
    }
  }
  @Input("excludeCss") excludeCss = false;
  @Input() ignoreMarginPaddingParcode: boolean
  @Input() set autoPrint(value) {
    //&&  this._AutoPrint == 0
    if (value) {
      setTimeout(() => {
        this._AutoPrint = 1;
        this.PrintView();
        this.printDiv();
      }, 200);
    }
  }
  selectedFile: File | null = null;
  mobile: string = '';
  caption: string = '';
  _AutoPrint: number = 0;
  @Input() printServer: boolean = false;
  _fileName;
  @Input() set fileName(name) {
    if (name) {
      this._fileName = name;
    }
  }
  @Input() printNo: number = 1;
  @Input() width: number;
  @Input() height: number;
  @Output() sectionChange = new EventEmitter<any>();
  @Output() htmlEvent = new EventEmitter<string[]>();
  @Output() isPrintBtnClicked = new EventEmitter<boolean>();
  htmlArr: string[] = [];
  safejsPDFScript: string = "";
  constructor(
    private ele: ElementRef,
    private _exportAsService: ExportAsService,
    public translate: TranslateService,
    public _medicalRepo: MedicalRepositoryService,
    private _SmsService: SmsService,
    private userSession: UserSessionService,
    private _toster: ToastService,


  ) {
    if (this.section === undefined) {
      this.section = "";
    }
  }


  ngOnChanges(changes) {
    if (changes.section && changes.section.currentValue !== undefined && changes.section.currentValue !== "") {
      console.log("changes.section.currentValue", changes.section.currentValue);
    } else {
      //this.clearComponent();
    }
  }
  ///--=================edite by eng/Mostafa Mahmoud==============
  // ngOnChanges() {
  //   this.clearComponent();
  // }

  // ngOnDestroy() {
  //   this.clearComponent();
  // }

  clearComponent() {
    if (this.printHtml5Iframe && this.printHtml5Iframe.nativeElement) {
      try {
        if (this.printHtml5Iframe.nativeElement.srcdoc !== undefined) {
          this.printHtml5Iframe.nativeElement.srcdoc = '';
        } else {
          const iframeDoc = this.printHtml5Iframe.nativeElement.contentDocument || this.printHtml5Iframe.nativeElement.contentWindow.document;
          if (iframeDoc && iframeDoc.body) {
            iframeDoc.body.innerHTML = '';
          }
        }
      } catch (error) {
        console.error("Error clearing iframe:", error);
      }
    }

    this.section = '';
    this.pgStyle = '';
  }

  PrintView() {
    try {
      if (this.printHtml5Iframe && this.printHtml5Iframe.nativeElement) {
        const iframeWindow = this.printHtml5Iframe.nativeElement.contentWindow;
        const iframeDocument = iframeWindow ? iframeWindow.document : null;

        if (iframeDocument && iframeDocument.body) {
          iframeDocument.body.outerHTML = this.getHtmlForView();
        } else {
          console.warn("Unable to access iframe document or body.");
        }
      }
    } catch (error) {
      console.error("Error during PrintView:", error);
      this.clearComponent();
    }
  }
  getHtmlForView() {
    const _section = document.getElementById(this.section);
    if (this.excludeCss) {
      this.cssRefs = "";
    }
    let html;
    let classAttribute = this.backgroundFlag ? 'class="backgroundPrintView10Enabled"' : 'class=""';

    if (this.translate.currentLang == "ar") {
      html = `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8"/>
            ${this.cssRefs}
          </head>
          <body style="direction: rtl;">
            <div ${classAttribute}>
              ${_section.innerHTML}
            </div>
          </body>
        </html>`;
    } else if (this.translate.currentLang == "en") {
      html = `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8"/>
            ${this.cssRefs}
          </head>
          <body style="direction: ltr;">
            <div ${classAttribute}>
              ${_section.innerHTML}
            </div>
          </body>
        </html>`;
    }
    return html;
  }
  afterPrint() {
    console.log("after print");
    this.ele.nativeElement.children[0].innerHTML = "";
    this.sectionChange.emit("");
    this.section = "";
  }
  /*
  printDiv() {

    if (this.section && this.section !== undefined && this.section !== '') {
      const originalContents = document.body.innerHTML;

      if (window) {
        if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
          const popup = window.open('', '_blank',
            `width=600,height=600,scrollbars=no,menubar=no,toolbar=no, location=no,status=no,titlebar=no`);

          popup.window.focus();
          popup.document.write(this.getHtmlForPrint());
          popup.onbeforeunload = function (event) {
            popup.close();
            return '.\n';
          };
          popup.onabort = function (event) {
            popup.document.close();
            popup.close();
          };
        } else {
          const popup = window.open('', '_blank', 'width=800,height=600');
          popup.document.open();

          popup.document.write(this.getHtmlForPrint());
          popup.document.close();
        }

        // popup.document.close();
      }

      return true;
    }
  }

  getHtmlForPrint() {
    const printContents = document.getElementById(this.section).innerHTML;
    if (this.excludeCss) {
      this.cssRefs = '';
    }
    const html =
      `<!DOCTYPE html>
    <html>
      <head>
         ${this.cssRefs}
      </head>
      <body onload="window.print()"
         ${printContents}
      </body>
    </html>`;
    return html;
  }

  */
  // loadScript() {
  //   return new Promise((resolve, reject) => {
  //     const script = document.createElement('script');
  //     script.type = 'text/javascript';
  //     script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jsPDF/2.4.0/jsPDF.umd.min.js';
  //     script.onload = resolve;
  //     script.onerror = reject;
  //     document.head.appendChild(script);
  //   });
  // }
  // private exportPdf() {
  //   this.loadScript().then(() => {
  //     const pdf = new jsPDF();
  //     // Use jsPDF functionalities here
  //     pdf.text(10, 10, 'Hello, world!');
  //     pdf.save('document.pdf');
  //   }).catch(error => {
  //     console.error('Error loading jsPDF:', error);
  //   });
  // }

  //  private convettopdf() {
  //    const printcontents = this.printHtml5Iframe.nativeElement.contentWindow.document.body;
  //    const pdf = new jsPDF();
  // pdf.text(10, 10, printcontents);
  //   pdf.save(`Mostafa.pdf`);
  //  }
  // private convetToPDF() {
  //   const iframe = this.printHtml5Iframe.nativeElement.contentWindow.document.body;
  //   html2canvas(iframe).then(canvas => {
  //     var imgWidth = 208;
  //     var imgHeight = canvas.height * imgWidth / canvas.width;
  //     const contentDataURL = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF.default('p', 'mm', 'a4'); // A4 size page of PDF
  //     let position = 0;
  //     pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
  //     pdf.save(`${this.section+'_'+this._medicalRepo.PatientCode}.pdf`);
  //   });
  // }
  //----------Eng/Mostafa Mahmoud
  //   private async convetToPDF() {
  //     const iframe = this.printHtml5Iframe.nativeElement.contentWindow.document.body;
  //     const canvas = await html2canvas(iframe);
  //     // Increase image size
  //     const scaleFactor = 5; // Adjust the scale factor as needed
  //     const enlargedCanvas = document.createElement('canvas');
  //     enlargedCanvas.width = canvas.width * scaleFactor;
  //     enlargedCanvas.height = canvas.height * scaleFactor;
  //     const context = enlargedCanvas.getContext('2d');
  //     context.scale(scaleFactor, scaleFactor);
  //     context.drawImage(canvas, 0, 0);
  //     const contentDataURL = enlargedCanvas.toDataURL('image/png');
  //     const pdf = new jsPDF.default('p', 'mm', 'a4'); // A4 size page of PDF
  //     const imgWidth = pdf.internal.pageSize.getWidth();
  //     const imgHeight = (enlargedCanvas.height * imgWidth) / enlargedCanvas.width;
  //     pdf.addImage(contentDataURL, 'PNG', 0, 0, imgWidth, imgHeight);
  //     const pdfBase64 = pdf.output('datauristring');
  //     const base64Content = pdfBase64.split(',')[1];
  //     this.downloadPDF(base64Content);
  // }
  // private downloadPDF(base64Content: string) {
  //   const byteCharacters = atob(base64Content);
  //   const byteNumbers = new Array(byteCharacters.length);
  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }
  //   const byteArray = new Uint8Array(byteNumbers);
  //   const blob = new Blob([byteArray], { type: "application/pdf" });

  //   const link = document.createElement("a");
  //   link.href = window.URL.createObjectURL(blob);
  //   link.download = `${this.section}_${this._medicalRepo.PatientCode}.pdf`;
  //   link.click();
  // }
  public async convetToPDF() {
    const iframe = this.printHtml5Iframe.nativeElement.contentWindow.document.body;
    const canvas = await html2canvas(iframe, { scale: 2, logging: true }); // Adjust scale as needed
    const contentDataURL = canvas.toDataURL('image/jpeg', 0.5); // Adjust quality (0.5 means 50% quality)
    const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
    const imgWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    pdf.addImage(contentDataURL, 'JPEG', 0, 0, imgWidth, imgHeight);
    const pdfBase64 = pdf.output('datauristring');
    this.pdfBase64.emit(pdfBase64)
    const base64Content = pdfBase64.split(',')[1];
    // pdf.save(`${this.section+'_'+this._medicalRepo.PatientCode}.pdf`);
  }

  //--=========================================================Eng/Mostafa Mahmoud End =======================================

  public async convertToPDFToFile() {
    const iframe = this.printHtml5Iframe.nativeElement.contentWindow;
    const iframeDoc = iframe.document;
    const iframeBody = iframe.document.body;
    let script = iframeDoc.querySelector('script[src*="fontawesome"]') as HTMLScriptElement;
    if (!script) {
      script = iframeDoc.createElement("script");
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/js/all.min.js";
      script.defer = true;
      iframeDoc.head.appendChild(script);
      await new Promise(resolve => script.onload = resolve);
    }
    const images = Array.from(iframeBody.getElementsByTagName('img')) as HTMLImageElement[];
    for (let img of images) {
      try {
        await this.loadImage(img);
        img.src = await this.convertImageToBase64(img);
      } catch (error) {
        console.error("Error loading image:", img.src, error);
      }
    }
    const icons = iframeDoc.querySelectorAll("i.fas, i.far, i.fal, i.fad, i.fab");
    for (let icon of icons) {
      const classes: string[] = Array.from(icon.classList) as string[];
      const faClass: string | undefined = classes.find(cls => cls.startsWith("fa-"));

      if (faClass) {
        const iconName = faClass.replace("fa-", "");
        const svg = document.createElement("span");

        svg.innerHTML = `
                <svg class="${classes.join(' ')}" xmlns="http://www.w3.org/2000/svg">
                    <use href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/sprites/solid.svg#${iconName}"></use>
                </svg>
            `;
        icon.replaceWith(svg);
      }
    }

    const canvas = await html2canvas(iframeBody, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      foreignObjectRendering: true,
      backgroundColor: '#ffffff'
    });

    const imageData = canvas.toDataURL("image/png");
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([600, 800]);
    const imageBytes = await fetch(imageData).then(res => res.arrayBuffer());
    const image = await pdfDoc.embedPng(imageBytes);

    const imgWidth = page.getWidth();
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const y = page.getHeight() - imgHeight - 20;

    page.drawImage(image, { x: 0, y, width: imgWidth, height: imgHeight });

    const pdfBytes = await pdfDoc.save();
    const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });
    const pdfFileName = `${this._whatsAppData.patientNameEn}_${this._whatsAppData.serviceNameEn}_${this._whatsAppData.patCode}.pdf`;
    this.selectedFile = new File([pdfBlob], pdfFileName, { type: 'application/pdf' });
    // const pdfLink = document.createElement("a");
    // pdfLink.href = URL.createObjectURL(pdfBlob);
    // pdfLink.download = pdfFileName;
    // pdfLink.click();
  }

  private async loadImage(img: HTMLImageElement): Promise<void> {
    return new Promise((resolve, reject) => {
      const newImg = new Image();
      newImg.crossOrigin = "anonymous";
      newImg.src = img.src;

      newImg.onload = () => {
        img.src = newImg.src;
        resolve();
      };
      newImg.onerror = () => {
        console.error(img.src);
        reject();
      };
    });
  }

  private async convertImageToBase64(img: HTMLImageElement): Promise<string> {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const newImg = new Image();
      newImg.crossOrigin = "anonymous";
      newImg.src = img.src;

      newImg.onload = () => {
        canvas.width = newImg.width;
        canvas.height = newImg.height;
        ctx?.drawImage(newImg, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };

      newImg.onerror = (error) => {
        console.error(img.src, error);
        reject(error);
      };
    });
  }
  //--=========================================================Eng/Mostafa Mahmoud End =======================================
  printDiv() {
    this.convetToPDF();
    this.isPrintBtnClicked.emit(true);
    console.log("print1");
    let cssfontAwsom = "";
    if (true) {
      cssfontAwsom = `<link type="text/css" rel="stylesheet" href="/assets/css/fontawesome-all.min.css">
                        <link rel="stylesheet" href="assets/css/emrgeneralprint.css">`;
    }
    if (this.section && this.section != undefined && this.section != "") {
      var printContentsElement = document.getElementById(this.section);
      var printContents = "";
      let classAttribute = this.backgroundFlag ? 'class="backgroundPrintView10Enabled"' : 'class=""';
      if (printContentsElement) {
        printContents = `<div ${classAttribute}>${printContentsElement.innerHTML}</div>`;
      }

      if (this.printServer) {
        this.htmlArr = [];
        for (let i = 0; i < this.printNo; i++) {
          const el = i;
          if (el == 0) {
            this.htmlArr.push(document.getElementById(this.section).innerHTML);
          } else {
            this.htmlArr.push(
              document.getElementById(this.section + el).innerHTML
            );
          }
        }
        console.log(this.htmlArr);
        this.htmlEvent.emit(this.htmlArr);
      } else {
        if (window) {
          if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
            var popup = window.open("", "_blank", "width=780,height=600,scrollbars=no,menubar=no,toolbar=no," + "location=no,status=no,titlebar=no");

            popup.document.write(
              '<!DOCTYPE html><html lang="ar"><head><meta http-equiv="Content-Type" content="text/html;charset=UTF-8"> ' +
              (this.excludeCss ? "" : '<link rel="stylesheet" href="/assets/css/gutenberg.css" ' + 'media="screen,print">' + cssfontAwsom) +
              (this.excludeCss ?
                '</head><body onload="window.print()" style="margin:0 10px;" class="' + (this.backgroundFlag ? 'reward-body' : 'body') + '">' :
                '</head><body onload="window.print()" style="' + (this.ignoreMarginPaddingParcode ? 'margin:0; padding:0' : '') + '" class="' + (this.backgroundFlag ? 'reward-body' : 'body') + '">'
              ) +
              printContents + '</body></html>'
            );

            popup.onbeforeunload = function (event) {
              popup.close();
              return ".\n";
            };
            popup.onabort = function (event) {
              popup.document.close();
              popup.close();
            };
          } else {
            var popup = window.open("", "_blank", "width=800,height=600");
            popup.document.open();
            popup.document.write(
              '<html lang="ar"><head><meta http-equiv="Content-Type" content="text/html;charset=UTF-8">' +
              (this.excludeCss ? "" : '<link rel="stylesheet" href="/assets/css/gutenberg.css" media="all">' + cssfontAwsom) +
              (this.excludeCss ?
                '</head><body onload="window.print()" style="margin:0 10px;" class="' + (this.backgroundFlag ? 'reward-body' : 'body') + '">' :
                '</head><body onload="window.print()"  style="' + (this.ignoreMarginPaddingParcode ? 'margin:0; padding:0' : '') + ' "  class="' + (this.backgroundFlag ? 'reward-body' : 'body') + '">'
              ) +
              printContents + '</body></html>'
            );

            popup.document.close();
          }

          popup.document.close();
        }
      }

      return true;
    }
  }


  // exportAsConfig: ExportAsConfig = {
  //   type: 'pdf', // the type you want to download
  //   elementIdOrContent: `${this.section}`, // the id of html/table element
  // }

  export() {
    // download the file using old school javascript method
    this._exportAsService
      .save(
        {
          type: "pdf", // the type you want to download
          elementIdOrContent: `${this.section}`, // the id of html/table element
        },
        `${this._fileName}`
      )
      .subscribe(() => {
        // save started
      });
  }

  fetchStylesheets() {
    var output: string = "";

    for (var i = 0; i < document.styleSheets.length; i++) {
      output =
        output +
        ' <link rel="stylesheet" type="text/css" href="' +
        window.document.styleSheets[i].href +
        '" /> ';
    }
    return output;
  }

  fetchscriptSheets() {
    var output: string = "";
    for (var i = 0; i < document.scripts.length; i++) {
      //output = output +' <script type="text/javascript" src="'+
      //         window.document.scripts[i].src +'" /> ';
    }
    return output;
  }

  async sendFile(): Promise<void> {
    if (!this.mobile) {
      this._toster.activateMsg(this.translate.currentLang == 'ar' ? 'رقم الهاتف خطأ' : 'Phone number is wrong');
      return;
    }
    await this.convertToPDFToFile();
    if (!this.selectedFile) {
      this._toster.activateMsg(this.translate.currentLang == 'ar' ? 'من فضلك حاول مرة أخرى' : 'Please try again');
      return;
    }
    this._SmsService.sendFile(this.selectedFile, this.mobile, this.caption).subscribe({
      next: (response) => {
        console.log('File sent successfully');
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

}

@NgModule({
  imports: [CommonModule],
  declarations: [PrintComponent],
  providers: [ExportAsService],
  exports: [PrintComponent, RouterModule],
})
export class PrintComponentModule { }
